var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M13.2519 2.85747V9.65069C13.2519 9.65069 13.2822 10.0146 13.6764 10.0146C14.0706 10.0146 14.0706 9.65069 14.0706 9.65069V2.85747C14.0706 2.85747 14.0706 1.82636 13.4641 1.3108C12.8063 0.613281 11.9176 0.613281 11.9176 0.613281H2.12273C2.12273 0.613281 1.24331 0.613281 0.636818 1.28047C0 1.85668 0 2.76649 0 2.76649V12.5621C0 12.5621 -2.95561e-05 13.4112 0.606493 13.9874C1.15231 14.6849 2.18338 14.6849 2.18338 14.6849H9.12773C9.12773 14.6849 9.43094 14.6849 9.43094 14.2907C9.43094 13.8661 9.12773 13.8661 9.12773 13.8661H2.18338C2.18338 13.8661 1.72848 13.8661 1.24328 13.4415C0.818766 13.108 0.818766 12.5621 0.818766 12.5621V2.76649C0.818766 2.76649 0.818796 2.25093 1.24331 1.85668C1.68577 1.44577 2.12273 1.46243 2.12273 1.46243H11.9176C11.9176 1.46243 12.4634 1.46243 12.797 1.85668C13.2519 2.22061 13.2519 2.85747 13.2519 2.85747Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 133",
    cx: 4.24568,
    cy: 5.10121,
    rx: 0.90974,
    ry: 0.909806
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M5.36604 7.31422L2 10.7108H7.48876C7.48876 10.7108 7.81264 10.3323 8.18623 10.1953C8.64209 10.0281 9.55084 10.1043 9.55084 10.1043C9.55084 10.1043 9.43542 9.2484 9.64181 8.76991C9.83419 8.32391 10.4303 7.89043 10.4303 7.89043L9.39922 4.67578L6.21513 8.76991L5.36604 7.31422Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 348",
    d: "M11.3867 9.71158C11.3867 9.71158 11.3867 9.34766 11.8416 9.34766C12.2358 9.34766 12.2358 9.71158 12.2358 9.71158V14.9885C12.2358 14.9885 12.2358 15.3827 11.8113 15.3827C11.3867 15.3827 11.3867 14.9885 11.3867 14.9885V9.71158Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 349",
    d: "M9.16077 12.7891C9.16077 12.7891 8.79688 12.7891 8.79688 12.3342C8.79687 11.9399 9.16077 11.9399 9.16077 11.9399H14.4373C14.4373 11.9399 14.8315 11.9399 14.8315 12.3645C14.8315 12.7891 14.4373 12.7891 14.4373 12.7891H9.16077Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.1b8864fbba819079f1e051dabc3c5fbf.svg";
export { ForwardRef as ReactComponent };